import _ from 'lodash'

const CONTACT_MAP_CONFIG = {
    section: _.select( '.c-section--contact-map' ),
    map: _.select( '.c-section--contact-map .map' ),
    filters: _.selectAll( '.c-section--contact-map .map__nav button' ),
    endpoint: 'contact/places/'
}

export default CONTACT_MAP_CONFIG